module.exports = __webpack_public_path__ + "static/media/Ball-Pen-Extra.00c0ab3f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ball-Pen-Extra.ttf
// module id = 3035
// module chunks = 68